<template>
  <div class="container">
    <div class="detail-content" v-if="detailInfo.state">
      <p class="title-name">实际到账金额</p>
      <p class="title-money">{{ detailInfo.real_money }}</p>

      <div class="bar-status">
        <!--个人提现一共有两种状态：state为7：订单关闭，state为8：打款完成-->
        <div class="state-box" v-if="detailInfo.state == 7">
          <div class="box-one">
            <img src="@/assets/images/icon_success.png" />
            <p class="txt-state">申请成功</p>
          </div>
          <div class="line"></div>
          <div class="box-two">
            <img src="@/assets/images/icon_failure.png" />
            <p class="txt-state">提现关闭</p>
          </div>
        </div>
        <div class="state-box" v-else-if="detailInfo.state == 8">
          <div class="box-one">
            <img src="@/assets/images/icon_success.png" />
            <p class="txt-state">申请成功</p>
          </div>
          <div class="line"></div>
          <div class="box-one">
            <img src="@/assets/images/icon_success.png" />
            <p class="txt-state">提现完成</p>
          </div>
        </div>
      </div>
      <div class="bill-list">
        <p class="item-wrap">
          <span class="name">税费</span>
          <span class="num">{{ detailInfo.taxe }}</span>
        </p>
        <p class="item-wrap">
          <span class="name">手续费</span>
          <span class="num">{{ detailInfo.service_charge }}</span>
        </p>
        <p class="item-wrap">
          <span class="name">提现金额</span>
          <span class="num">{{ detailInfo.money }}</span>
        </p>
        <p class="item-wrap">
          <span class="name">到账账号</span>
          <span class="num">{{ detailInfo.acc_id | regroupAcc }}</span>
        </p>
        <!-- <p class="item-wrap">
          <span class="name">申请时间</span>
          <span class="num">{{ detailInfo.date }}</span>
        </p> -->
        <p class="item-wrap">
          <span class="name">订单号</span>
          <span class="num">{{ detailInfo.id }}</span>
        </p>
        <!-- <p class="item-wrap">
          <span class="name">钱包余额</span>
          <span class="num">{{ detailInfo.wallet_num }}</span>
        </p> -->
      </div>
    </div>
    <div class="btn-back" @click="gotoIncome">
      <div class="content">返回结算中心</div>
    </div>
  </div>
</template>

<script>
import { getRecordDetail } from '@/api/income';
export default {
  data() {
    return {
      auditProgress: 0,
      remitProgress: 2,
      detailInfo: {},
    };
  },
  computed: {},
  filters: {
    regroupAcc(val) {
      if (val) {
        if (typeof val == 'number') {
          return `游戏账号（${val}）`;
        } else {
          let reg1 = /[\u4e00-\u9fa5]{2,}/gi;
          let reg2 = /(\d{1,3})+(?:\.\d+)?/gi;
          let txt1 = val.replace(reg2, '');
          let txt2 = val.replace(reg1, '');
          let res = `${txt1}（${txt2.substring(txt2.length - 4)} ）`;
          return res;
        }
      }
    },
    regroupTime(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      const hours = time.getHours().toString().padStart(2, '0');
      const minute = time.getMinutes().toString().padStart(2, '0');
      const second = time.getSeconds().toString().padStart(2, '0');

      return (
        year +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hours +
        ':' +
        minute +
        ':' +
        second
      );
    },
  },
  mounted() {
    this.fetchRecordDetail();
  },
  methods: {
    //获取收益详情
    async fetchRecordDetail() {
      try {
        let data = {
          id: this.$route.query.id,
          // money_type: this.$route.query.money_type,
        };
        const res = await getRecordDetail(data);
        this.detailInfo = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    gotoIncome() {
      this.$router.push({ name: 'IncomeSettlement' });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
}
.detail-content {
  // min-height: calc(100vh - 103px);
  // height: 1060px;
  padding: 0 68px;
  color: #262626;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 26px;
  .title-name {
    margin-top: 35px;
    margin-bottom: 48px;
    font-size: 34px;
    width: 100%;
    text-align: center;
  }
  .title-money {
    font-weight: 500;
    color: #000000;
    width: 100%;
    font-size: 64px;
    text-align: center;
  }
  .bar-status {
    margin-top: 68px;
    .state-box {
      display: flex;
      justify-content: center;
      color: #8c8c8c;
      align-items: center;
      font-size: 28px;
      .box-one {
        text-align: center;
        margin-right: -38px;
        img {
          height: 54px;
          width: 54px;
        }
      }
      .box-two {
        text-align: center;
        margin-left: -38px;
        img {
          height: 54px;
          width: 54px;
        }
      }
      .line {
        width: 227px;
        height: 4px;
        margin-bottom: 60px;
        background: #18d125;
        margin-left: 30px;
        border-radius: 4px 0px 0px 4px;
      }
    }
  }
  .bill-list {
    margin-top: 78px;
    width: 100%;
    .item-wrap {
      display: flex;
      font-size: 28px;
      color: #595959;
      justify-content: space-between;
      margin-bottom: 42px;
      .num {
        font-weight: 500;
      }
    }
  }
}
.btn-back {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  margin-top: 72px;
  .content {
    background: #fd9b21;
    border-radius: 8px;
    text-align: center;
    color: #ffffff;
    font-size: 32px;
    padding-top: 23px;
    width: 360px;
    height: 90px;
  }
}
</style>
